<template>
  <div class="page-container">
    <div class="container" v-if="info && loaded" ref="container">
      <NavBar
        class="nav-bar"
        :title="title"
        :options="options"
        :zIndex="10"
        @click-right="bindShare"
      >
        <template slot="right">
          <div class="share iconfont icon-share"></div>
        </template>
      </NavBar>
      <div
        class="result"
        :style="{ backgroundPosition: isApp ? 'center top' : 'center -18vw' }"
        id="result"
        v-if="!isError"
      >
        <img
          class="result-bg"
          :src="bgList[info.status]"
          :style="{ top: isApp ? '0vw' : '-18.67vw' }"
          alt=""
        />
        <div class="top-content" v-show="showPoster">
          <div class="top-logo">
            <img
              class="logo"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ab0b15a5b855539a03ed4d3681397970.png"
              alt=""
            />
          </div>
        </div>
        <img
          class="food-pop"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_food_tip"
          @click="bindShowPop"
          :style="{ top: isApp ? '69vw' : '51vw' }"
        />
        <div
          class="content"
          :style="{ marginTop: isApp && !showPoster ? '82.67vw' : '64vw' }"
        >
          <div class="white-item ingredient-content">
            <div class="desc">
              <img class="read-image" :src="info.cdnUrl" alt="" />
              <div class="text">这份配料表中包含：</div>
            </div>
            <div class="list">
              <div class="item" v-for="(item, index) in info.data" :key="index">
                <div class="item-top" @click="bindToggle(index)">
                  <img class="icon-a" :src="item.icon" />
                  <div class="name">{{ item.name }}</div>
                  <div class="item-right">
                    <span class="ingredient-num">{{ item.data.length }}</span
                    ><span>项</span
                    ><span
                      class="icon-b iconfont icon-black"
                      :style="{ transform: item.open ? 'rotate(180deg)' : '' }"
                    ></span>
                  </div>
                </div>
                <div class="el-list" v-show="item.open">
                  <div
                    class="el-item"
                    v-for="(item1, index1) in item.data"
                    :key="index1"
                  >
                    <div>{{ item1.name }}</div>
                    <div class="line">
                      <div
                        class="line-item"
                        v-for="(lineitem, lineindex) in 30"
                        :key="lineindex"
                      ></div>
                    </div>
                    <img
                      class="food-icon"
                      :src="
                        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_food_icon_' +
                        item1.status
                      "
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="white-item interpret">
            <div class="top" v-if="CommonIncomingData" @click="jumpToStarPage">
              <img
                class="avatar"
                :src="CommonIncomingData.head_portrait"
                alt=""
                v-buried
                data-buried="BG_PLXQ_YYSZY"
                v-clickBuried
                data-click-buried="CLICK_PLXQ_YYSZY"
              />
              <div class="right">
                <div class="coach-name">{{ CommonIncomingData.name }}</div>
                <div class="desc">{{ CommonIncomingData.title }}</div>
              </div>
              <!--   <div class="c-btn"  v-clickBuried data-click-buried="CLICK_PLXQ_ZX"  @click.stop="jumpIncoming">立即咨询</div> -->
            </div>
            <div class="bottom" v-if="info.text">
              <div class="title">营养师解读</div>
              <div
                class="desc"
                :class="{ 'desc-hidden': !lookMore }"
                v-html="info.text"
              ></div>
              <div class="look-more" @click="bindLookMore" v-show="!showPoster">
                <span
                  class="more-icon iconfont icon-black"
                  :style="{ transform: lookMore ? 'rotate(180deg)' : '' }"
                ></span>
              </div>
            </div>
          </div>
          <div class="white-item references" v-show="!showPoster">
            <div class="title">相关说明及资料参考：</div>
            <div class="list">
              <div
                class="item"
                v-for="(item, index) in referencesData"
                :key="index"
              >
                <div class="dot"></div>
                <div class="text">{{ item }}</div>
              </div>
            </div>
          </div>
          <div class="test-desc">- betterWE营养师团队持续完善中 -</div>
        </div>
        <div class="bottom-logo" v-show="showPoster">
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/betterwe_logo.png"
            alt=""
          />
          <div class="center">
            <div class="text1">betterWE</div>
            <div class="text2">扫码下载app ，获取更多配料解析</div>
          </div>
          <img
            class="qrcode"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_download_app"
            alt=""
          />
        </div>
      </div>
      <van-overlay :show="showPop" @click="showPop = false" z-index="11">
        <FoodIllustratefrom @close="bindPopClose"></FoodIllustratefrom>
      </van-overlay>
      <!-- 分享组件 -->
      <van-overlay :show="showShare" @click="showShare = false" z-index="11">
        <ShareComponent
          v-if="showShare"
          class="share-container"
          @close="bindCloseShare"
          @link="bindClickLink"
          @image="bindClickImage"
          :copyUrl="qrcodeUrl"
        />
      </van-overlay>
      <PosterComponent
        v-if="showPoster"
        @close="bindClosePoster"
        el="result"
        @error="bindPosterError"
        @success="bindPosterSuccess"
      ></PosterComponent>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#888888"
      color="#888888"
      vertical
      >加载中...</van-loading
    >
    <!-- 咨询按钮 -->
    <div class="connect-btn" v-if="userStatus == 0" @click="bindConnect">
      <span>加入减脂食品研究所</span>
      <div
        class="connect-flag"
        :style="{ background: connectList[info.status].bgColor }"
      >
        <span
          class="iconfont icon-ic-deng"
          :style="{ color: connectList[info.status].iconColor }"
        ></span>
        <span>{{ connectList[info.status].text }}</span>
        <div
          class="circle"
          :style="{
            borderBottom: '10px solid ' + connectList[info.status].bgColor
          }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/app/nav-bar/index.vue'
import FoodIllustratefrom from './components/food-illustrate.vue'
import ShareComponent from './components/share.vue'
import PosterComponent from './components/poster.vue'
export default {
  components: {
    NavBar,
    FoodIllustratefrom,
    ShareComponent,
    PosterComponent
  },
  data() {
    return {
      bgList: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_red_food_bg',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_yellow_food_bg?time=1',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_green_food_bg'
      ],
      connectList: [
        {
          iconColor: 'rgba(255, 87, 110, 1)',
          bgColor: 'rgba(255, 237, 237, 1)',
          text: '红灯食物想吃怎么办？'
        },
        {
          iconColor: 'rgba(254, 167, 0, 1)',
          bgColor: 'rgba(255, 243, 230, 1)',
          text: '黄灯食物吃多少合适？'
        },
        {
          iconColor: 'rgba(1, 188, 137, 1)',
          bgColor: 'rgba(238, 255, 250, 1)',
          text: '绿灯食物吃多少合适？'
        }
      ],
      userStatus: 1,
      resultBg: '',
      isApp: false,
      loaded: false,
      showShare: false,
      showPoster: false,
      maxOffset: 100, //滚动最大位移
      title: '配料解析结果',
      qrcodeUrl: location.href,
      showPop: false,
      isError: false,
      lookMore: false,
      options: {
        barBackgroundColor: 'transparent'
      },
      //食物风险状态
      foodStatusIcon: ['icon-reeor', 'icon-warning', 'icon-success'],
      statusText: ['', '红灯', '黄灯', '绿灯'],
      statusIconImage: {
        反式脂肪酸:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_1',
        精致碳水:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_2',
        添加剂:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_3',
        添加剂:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_4',
        蛋白质:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_5',
        油脂: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_6',
        维生素:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_7',
        益生菌:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_8',
        矿物质:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_9',
        其他: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_10'
      },
      foodStatusImage: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_red_food',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_yellow_food',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_green_food'
      ],
      info: null,
      //参考
      referencesData: [
        '因文字大小、图片清晰度等原因，可能会出现识别错误的情况，实际请以包装上的配料文字为准',
        '2020年《中国居民营养与慢性病状况报告》、中华人民共和国国家标准化指导性技术文件《GB/Z21922-2008 食品营养成分基本术语》',
        '中华人民共和国国家标准《GB28050-2011 食品安全国家标准 预包装食品营养标签通则》、中华人民共和国国家标准《GB2760-2007 食品添加剂使用卫生标准》',
        '中华人民共和国国家标准《GB28307-2012 食品安全国家标准 食品添加剂 麦芽糖醇和麦芽糖醇液》、《中国营养科学全书(第2版)》',
        '《中国食物成分表标准版(第6版)》、《营养与食品卫生学(第8版)》、《中国居民膳食指南(2006)》',
        '分析结果仅供参考，不作为医疗推荐'
      ],
      CommonIncomingData: null
    }
  },
  created() {
    this.isApp = this.$http._isApp()
    this.getData()
    this.getUserStatus()
    //埋点 配料表使用成功
    this.$buryPoint('APP_INGREDIENT_USE_SUCCESS', {})
    this.getCommonIncomingUrl()
  },
  mounted() {
    this.addDomEvent()
  },
  beforeDestroy() {
    this.removeDomEvent()
  },
  methods: {
    bindLookMore() {
      this.lookMore = !this.lookMore
    },
    getUserStatus() {
      this.$http
        .getBaseApp('tool/Ingredient/judgeUserIdentity', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.userStatus = res.data.code
          }
        })
        .catch(() => {})
    },
    //联系营养师
    bindConnect() {
      if (this.$http._isApp()) {
        let path =
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252Ff5bb420ede36f4fd0e262b243cf7c9cf.png'
        this.$betterwe.jumpRoute(path)
      }
    },
    getData() {
      if (!this.$route.query.data) {
        return
      }
      let data = JSON.parse(this.$route.query.data) || {}
      data.status = (data.food && data.food.attribute - 1) || 0
      data.data.map((item) => {
        item.open = false
        item.icon =
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_icon_' +
          item.id
        item.data.map((item1) => {
          let status = this.statusText.indexOf(item1.attribute_name)
          item1.status = status >= 0 ? status : 1
        })
      })
      this.info = data
      this.loaded = true
    },
    bindCloseShare() {
      this.showShare = false
    },
    bindClosePoster() {
      this.showPoster = false
    },
    bindShare() {
      this.showShare = true
    },
    bindToggle(index) {
      this.info.data[index].open = !this.info.data[index].open
    },
    bindShowPop() {
      this.showPop = true
    },
    addDomEvent() {
      document.addEventListener('scroll', this.bindScroll)
    },
    removeDomEvent() {
      document.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop = e.target.documentElement.scrollTop
      if (scrollTop <= this.maxOffset) {
        this.options.barBackgroundColor =
          'rgba(255,255,255,' + scrollTop / this.maxOffset + ')'
      } else {
        this.options.barBackgroundColor = '#ffffff'
      }
    },
    bindPopClose() {
      this.showPop = false
    },
    //分享点击链接
    bindClickLink(index) {
      switch (index) {
        case 0:
          this.createPoster()
          break
        case 1:
          this.shareWechatFriend()
          break
        case 2:
          this.shareWechat()
          break
      }
      this.showShare = false
    },
    bindClickImage(index) {
      switch (index) {
        case 0:
          this.saveImage()
          break
        case 1:
          this.shareImageToWechatFriend()
          break
        case 2:
          this.shareImageToWechat()
          break
      }
      this.showShare = false
    },
    //生成海报
    createPoster() {
      this.info.data.map((item) => {
        item.open = true
      })
      this.$refs.container.scrollTop = 0
      setTimeout(() => {
        this.showPoster = true
      }, 100)
    },
    //分享好友
    shareWechatFriend() {},
    //分享微信朋友圈
    shareWechat() {},
    //保存图片
    saveImage() {},
    shareImageToWechatFriend() {},
    shareImageToWechat() {},
    bindPosterSuccess() {},
    bindPosterError() {},
    async getCommonIncomingUrl() {
      let res = await this.$http
        .getBaseApp('api/v3/expert/getCommonIncomingUrl', { source_type: 6 })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.CommonIncomingData = res.data
        }
      }
    },
    jumpToStarPage() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.router)
    },
    jumpIncoming() {
      this.$betterwe.jumpRoute(this.CommonIncomingData.incoming_url)
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container {
  overflow: hidden;
  background-color: #f9f9f9;
}

.container {
  /*  height: 100vh;
  overflow-y: scroll; */
  margin-bottom: 100px;
}

.result {
  position: relative;
  overflow: hidden;
  background-size: contain;
  background-color: #f9f9f9;
  background-position: center top;
  background-repeat: no-repeat;

  .result-bg {
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
  }

  .content {
    position: relative;
    z-index: 1;
  }
}

.linaer-gradient-2 {
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_green_food_bg');
}

.linaer-gradient-1 {
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_yellow_food_bg');
}

.linaer-gradient-0 {
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_red_food_bg');
}

.nav-bar {
  .share {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
  }
}

.food-pop {
  width: 21px;
  height: 21px;
  object-fit: contain;
  position: absolute;
  left: 224px;
  top: 191px;
  margin-bottom: 30px;
}

.content {
  width: 335px;
  margin: 0px auto 20px;
  margin-top: 240px;

  .white-item {
    background: #ffffff;
    border-radius: 16px;
    margin-bottom: 16px;
  }

  .ingredient-content {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    padding: 16px;

    .tips {
      width: 142px;
      margin: 0 auto 0 97px;
      margin-top: -80px;
      margin-bottom: 18px;
      position: relative;

      .image {
        width: 100%;
      }

      .res-container {
        position: absolute;
        width: 100%;
        height: 60px;
        left: 0%;
        bottom: 29%;
        overflow: hidden;
      }

      .res-image-content {
        position: absolute;
        width: 60px;
        height: 60px;
        left: 39%;
        bottom: 0;
        transform: translate(-50%, 0%);
        box-shadow: 6px 6px 1px rgba(0, 0, 0, 0.3);

        .res-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .desc {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .read-image {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 12px;
      }

      .text {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }
    }

    .list {
      .item {
        background: #f7f7f7;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 8px;

        .item-top {
          display: flex;
          align-items: center;

          .icon-a {
            width: 25px;
            height: 25px;
            object-fit: contain;
          }

          .name {
            margin: 0 10px;
            width: 170px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            height: 20px;
            font-size: 14px;
            // font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: 20px;
          }

          .item-right {
            display: flex;
            align-items: center;
          }

          .ingredient-num {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #6236ff;
            margin-right: 4px;
          }

          .icon-b {
            text-align: center;
            vertical-align: middle;
            box-sizing: border-box;
            margin-left: 8px;
            width: 16px;
            height: 16px;
            line-height: 14px;
            color: #999;
            font-weight: 600;
            background: #ffffff;
            border-radius: 50%;
            border: 1px solid #f1f1f1;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 8px;
            color: #999999;
            transition: transform 0.3s;
          }
        }

        .el-list {
          margin-top: 18px;
          padding: 10px;
          box-sizing: border-box;
          background: #ffffff;
          border-radius: 4px;

          .el-item {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            line-height: 17px;
            margin-bottom: 10px;

            .line {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              height: auto;
              //border-bottom: 1px dashed #888;
              margin: 0px 10px;
              display: flex;
              align-items: center;

              .line-item {
                width: 3px;
                height: 1px;
                background-color: #888;
                margin-right: 3px;
              }
            }

            .food-icon {
              width: 17px;
              height: 17px;
              object-fit: contain;
            }
          }

          .el-item:last-child {
            margin-bottom: 0px;
          }
        }
      }
    }
  }

  .interpret {
    border-radius: 16px;
    overflow: hidden;

    .bottom {
      padding: 15px 20px;
      background-color: #fff;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 20px;
        margin-bottom: 10px;
      }

      .desc {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
      }

      .desc-hidden {
        overflow: hidden;
        max-height: 110px;
      }

      .look-more {
        text-align: center;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);

        .more-icon {
          text-align: center;
          vertical-align: middle;
          box-sizing: border-box;
          margin-left: 8px;
          width: 16px;
          height: 16px;
          line-height: 14px;
          color: #999;
          font-weight: 600;
          background: #ffffff;
          border-radius: 50%;
          border: 1px solid #f1f1f1;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 8px;
          color: #999999;
          transition: transform 0.3s;
        }
      }
    }

    .top {
      position: relative;
      background: rgba(242, 239, 255, 1);
      padding: 16px 10px;
      display: flex;
      align-items: center;

      .avatar {
        width: 42px;
        height: 42px;
        border-radius: 12px;
        margin-right: 8px;
        object-fit: cover;
      }

      .right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;

        .coach-name {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: bold;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
          margin-bottom: 3px;
        }

        .desc {
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.6);
          line-height: 16px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .c-btn {
        margin-left: 10px;
        width: 74px;
        height: 31px;
        background: linear-gradient(149deg, #9071ff 0%, #7d9afc 100%);
        border-radius: 16px;
        font-weight: bold;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        line-height: 31px;
      }
    }

    .top::after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #fff;
      bottom: -1px;
      left: 25px;
    }
  }

  .references {
    padding: 20px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.4);
    line-height: 14px;

    .title {
      margin-bottom: 6px;
      color: rgba(0, 0, 0, 0.8);
    }

    .list {
      .item {
        position: relative;
        margin-bottom: 6px;
        display: flex;

        .dot {
          margin-top: 4px;
          width: 4px;
          height: 4px;
          background: #d8d8d8;
          border-radius: 50%;
          margin-right: 5px;
        }

        .text {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
        }
      }
    }
  }

  .test-desc {
    margin-bottom: 16px;
    text-align: center;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 14px;
  }
}

.top-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 69px;

  .top-logo {
    background: #ffffff;
    height: 100%;
    padding: 16px 0px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      height: 100%;
      object-fit: contain;
    }
  }
}

.bottom-logo {
  width: 375px;
  height: 88px;
  background: #ffffff;
  padding: 0px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  .logo {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    margin-right: 10px;
  }

  .center {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.8);
    font-family: PingFangSC-Medium, PingFang SC;

    .text1 {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
    }

    .text2 {
      font-size: 10px;
      white-space: nowrap;
      text-overflow: hidden;
      overflow: hidden;
    }
  }

  .qrcode {
    width: 64px;
    height: 64px;
  }
}

.share-container {
  position: absolute;
  left: 0;
  bottom: 0;
}

.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}

.connect-btn {
  position: fixed;
  left: 50%;
  z-index: 10;
  bottom: 30px;
  transform: translate(-50%, 0%);
  width: 315px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  background: #6236ff;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;

  .connect-flag {
    position: absolute;
    right: 2px;
    bottom: 34px;
    height: 36px;
    border-radius: 18px;
    background: #ffeded;
    box-shadow: 0px 4px 6px 0px rgba(63, 26, 193, 0.21);
    font-size: 11px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    padding: 0px 8px;
    display: flex;
    align-items: center;

    .iconfont {
      margin-right: 2px;
    }

    .circle {
      position: absolute;
      bottom: -3px;
      left: 20px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 10px solid #ffeded;
      transform: rotate(90deg);
    }
  }
}
</style>
